import React from "react";
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Modal,
  Row,
  Switch,
  Typography,
  message,
  Tag,
  Layout,
  Col,
  Tooltip,
  Spin,
  Divider,
} from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currentAnalyzedArticle,
  getAnalyzeArticle,
} from "../../../../Redux/Slice/DataSlice";
import {
  NewsCardButton,
  StyledList,
  StyledModalClose,
  StyledNewsCard,
  TitleContent,
  TitleText,
} from "./styles";
import styled from "styled-components";
import { useKeycloak } from "@react-keycloak/web";
import dayjs from "dayjs";

const { Paragraph, Text, Title } = Typography;
const { Content } = Layout;

// Helper function to get article ID consistently
const getArticleId = (article: any) => {
  return article?.article_id || article?._id || article?.id;
};

interface StyledRowProps {
  wordCount: number;
}

const StyledRow = styled(Row)<StyledRowProps>`
  max-height: ${(props) =>
    props.wordCount <= 400 ? "100% !important" : "50vh"};
  overflow: auto;
`;

const StyledContentRow = styled(Row)<StyledRowProps>`
  max-height: ${(props) =>
    props.wordCount <= 400 ? "100% !important" : "50vh"};
  overflow-y: auto;
  overflow-x: hidden;
`;

const NewsCard = ({ news, add, newsCardView, item }: any) => {
  const [showFullArticle, setShowFullArticle] = useState(false);
  const [isAnalysisModelOpen, setIsAnalysisModelOpen] = useState(false);
  const [ellipsis, setEllipsis] = useState(true);
  const [modelData, SetModalData] = useState<any>({});
  const [analysisModelData, SetAnalysisModalData] = useState<any>({});
  const [messageApi, contextHolder] = message.useMessage();
  const drawerData = useSelector((state: any) => state.news.selectedArticles);
  const [analyzeId, setAnalyzeId] = useState("");
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const {
    analyzedArticles: analyzedArticles,
    loading: analyzeLoading,
    success: analyzeSuccess,
    currentArticle,
  } = useSelector((state: any) => state.data.analyzeData);

  const SetshowFullArticle = (item) => {
    setShowFullArticle(!showFullArticle);
  };

  const showAnalysisModal = (item) => {
    SetAnalysisModalData(item);
    setIsAnalysisModelOpen(true);
  };

  const handleAnalysisCancel = () => {
    setIsAnalysisModelOpen(false);
  };

  <Switch
    checked={ellipsis}
    onChange={() => {
      setEllipsis(!ellipsis);
    }}
  />;

  const info = () => {
    messageApi.success("Article added.");
  };
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "red" }} spin />
  );

  const isArabic = (lang?: string) => {
    if (!lang) return false;
    const lower = lang.toLowerCase();
    return lower.startsWith("ar") || lower === "arabic";
  };

  // Helper function to get the publication date from either fetched or reported news
  const getPublicationDate = (article: any) => {
    return article?.articlePubDate || article?.created_at || "";
  };

  // Format date as DD-MM-YYYY and time in local format
  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const date = dayjs(dateString);
    const formattedDate = date.format("DD-MM-YYYY");
    const formattedTime = date.format("h:mm A");
    return `${formattedDate} ${formattedTime}`;
  };

  const analyzeArticles = (content, id, lang) => {
    // Normalize language: API returns "Arabic" or "English" (capitalized)
    // Convert to lowercase for API: "english", "arabic", or "urdu"
    const normalizeLanguage = (lang?: string) => {
      if (!lang) return "english";
      const lower = lang.toLowerCase();
      if (lower.startsWith("ar")) return "arabic";
      if (lower.startsWith("ur")) return "urdu";
      return "english";
    };
    
    const language = normalizeLanguage(lang);
    setAnalyzeId(id);
    dispatch(
      getAnalyzeArticle({
        article: content,
        id: id,
        token: keycloak.token,
        language: language,
      })
    );
  };

  const analysis = analyzedArticles
    ?.filter((obj) => obj.id === news.article_id)[0]
    ?.response?.slice(
      analyzedArticles?.filter((obj) => obj.id === news.article_id)[0]?.response
    );

  const truncateTitle = (title: any) => {
    if (title.length > 50) {
      return title.substring(0, 80) + "...";
    }
    return title;
  };

  const wordCount = modelData.content?.split(/\s+/).length;

  const isDisabled = false;
  const hasNoTokens = false; // Always allow generation

  return (
    <>
      <Col xs={24} md={24} lg={24} style={{ margin: "2px" }}>
        <StyledNewsCard
          key={news.article_id}
          onClick={(e) => {
            e.stopPropagation();

            if (
              !analyzedArticles.some(
                (newsArticle) => newsArticle.id === news.article_id
              )
            ) {
              dispatch(currentAnalyzedArticle(news.article_id));
              analyzeArticles(news.content, news.article_id, news.language);
            }

            if (isDisabled) {
              message.error("You are not subscribed to use our services");
            } else if (hasNoTokens) {
              message.error("You do not have enough text tokens");
            } else {
              showAnalysisModal(news);
            }
          }}
          hoverable
        >
          <Row
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <TitleContent dir={isArabic(news.language) ? "rtl" : "ltr"}>
              <Row>
                <TitleText
                  ellipsis={ellipsis ? { rows: 3, expandable: false } : false}
                >
                  <strong
                    style={{
                      fontFamily:
                        isArabic(news.language) ? "Arial" : "Inria Serif",
                    }}
                  >
                    {news.title}
                  </strong>
                </TitleText>
              </Row>
            </TitleContent>

            <Content
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
              }}
            >
              <Row justify="space-between">
                <Text
                  ellipsis={{ tooltip: news.source }}
                  style={{
                    fontFamily: isArabic(news.language) ? "Arial" : "Arial",
                    maxWidth: "60%",
                  }}
                >
                  {news.source}
                </Text>
                <Tag
                  style={{
                    fontFamily: isArabic(news.language) ? "Arial" : "Arial",
                  }}
                  color="red"
                >
                  {news.genre}
                </Tag>
              </Row>
            </Content>

            <Divider style={{ margin: "12px 0" }} />
            <Content
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
              }}
            >
              <Row justify="space-between">
                <Col>
                  <Text
                    style={{
                      fontFamily:
                        isArabic(news.language) ? "Arial" : "Arial",
                      fontSize: "12px",
                      color: "grey",
                    }}
                  >
                    {formatDate(getPublicationDate(news))}
                  </Text>
                </Col>
                <Col>
                  <Tooltip placement="top">
                    <NewsCardButton
                      style={{
                        borderRadius: "0px",
                        zIndex: "0",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        add(news);
                        info();
                      }}
                      type="primary"
                    >
                      {drawerData.some((item) =>
                        getArticleId(item) === getArticleId(news)
                      ) ? (
                        <CheckCircleFilled
                          style={{ fontSize: "28px", color: "red" }}
                        />
                      ) : (
                        <CheckCircleOutlined
                          style={{ fontSize: "28px", color: "black" }}
                        />
                      )}
                    </NewsCardButton>
                  </Tooltip>
                </Col>
              </Row>
            </Content>
          </Row>
        </StyledNewsCard>
      </Col>

      <Modal
        width={900}
        open={isAnalysisModelOpen}
        onCancel={handleAnalysisCancel}
        closeIcon={false}
        footer={[
          <>
            <StyledModalClose
              type="primary"
              disabled={analyzeLoading}
              onClick={SetshowFullArticle}
            >
              {showFullArticle ? "View Analyzed Article" : "View Full Article"}
            </StyledModalClose>
            <StyledModalClose type="primary" onClick={handleAnalysisCancel}>
              Close
            </StyledModalClose>
          </>,
        ]}
      >
        <Row justify={"space-between"}>
          <Text
            ellipsis={{ tooltip: news.source }}
            style={{
              fontFamily: isArabic(news.language) ? "Arial" : "Arial",
              fontSize: "18px",
              fontWeight: "600",
              borderBottom: "1px groove #192238",
              boxShadow: "1 1 1",
              maxWidth: "70%",
            }}
          >
            {news.source}
          </Text>
          <Tag
            style={{
              fontFamily: isArabic(news.language) ? "Arial" : "Arial",
              fontWeight: "600",
              fontSize: 14,
              alignContent: "center",
            }}
            color="red"
          >
            {news.genre}
          </Tag>
        </Row>

        <Row
          dir={isArabic(analysisModelData.language) ? "rtl" : "ltr"}
          justify={"start"}
          style={{ marginTop: "30px" }}
        >
          <Title
            dir={isArabic(analysisModelData.language) ? "rtl" : "ltr"}
            style={{
              fontSize: "26px",
              fontFamily:
                isArabic(analysisModelData.language)
                  ? "Arial"
                  : "Inria Serif",
            }}
          >
            {analysisModelData?.title}
          </Title>
        </Row>
        {analyzeLoading ? (
          <StyledRow
            wordCount={wordCount}
            align="middle"
            justify="center"
            style={{ height: "50vh" }}
          >
            <Spin indicator={antIcon} />
            <Text style={{ marginLeft: 10, color: "red" }}>
              Analyzing Article
            </Text>
          </StyledRow>
        ) : (
          <>
            {showFullArticle ? (
              <div
                dir={isArabic(analysisModelData.language) ? "rtl" : "ltr"}
              >
                <Text
                  style={{
                    marginTop: "10px",
                    fontFamily: "Lato",
                    fontSize: "13px",
                    color: "grey",
                  }}
                >
                  {formatDate(getPublicationDate(news))}
                </Text>
                <br></br>
                <br></br>
                <StyledContentRow
                  wordCount={wordCount}
                  dir={isArabic(analysisModelData.language) ? "rtl" : "ltr"}
                >
                  <Paragraph
                    style={{
                      fontFamily:
                        isArabic(analysisModelData.language) ? "Arial" : "",
                    }}
                  >
                    {analysisModelData?.content}
                  </Paragraph>
                </StyledContentRow>
              </div>
            ) : (
              <Row
                style={{
                  maxHeight: wordCount <= 400 ? "100% !important" : "50vh",
                  overflowY: "auto",
                }}
                dir={isArabic(analysisModelData.language) ? "rtl" : "ltr"}
              >
                <StyledList
                  style={{
                    fontFamily:
                      isArabic(analysisModelData.language)
                        ? "Arial"
                        : "Arial",
                  }}
                  dangerouslySetInnerHTML={{ __html: analysis }}
                />
              </Row>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default NewsCard;
